import * as Feather from "react-feather";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactSlider from "react-slider";
import { useCart } from "../context/UserCartCountContext";
import { discountValue, getCustomer, isEmptyObj, ratingAvg1 } from "../../include/function";
import { api, baseURL, customerReqConfig } from "../../include/api";
import { useNotification } from "../../Toast/ToastProvider";
import { ERROR, SUCCESS } from "../../include/constant";
import { useParams } from "react-router-dom";
import "../../styles/CategoryProductList.css";
import { addToCartHandler, handleWishlist, loadCartData, loadWishlist } from "../../helper/cartUtils";
import CatProductListStyle from "./CatProductListStyle";
import CatProductGridStyle from "./CatProductGridStyle";

const BannersCategoryProductList = ({ categoryList, brandList }) => {
  const { categoryID } = useParams();
  let [grid, setGrid] = useState(false);
  let [active, setActive] = useState(false);
  let sidebarController = () => {
    setActive(!active);
  };
  const [productList, setProductList] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(true);
  const customer = getCustomer();
  const [cartData, setCartData] = useState({});
  const { fetchCartCount } = useCart();
  const [priceRange, setPriceRange] = useState([0, 1000]);
  const [filteredList, setFilteredList] = useState([]);
  const [priceLimits, setPriceLimits] = useState({ min: 0, max: 1000 });
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [sortBy, setSortBy] = useState();
  const [filteredBrands, setFilteredBrand] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);



    const getSellingPriceForFilter = (item, customer) => {
      const isB2C = !customer || customer.customerType === "individual";
      const basePrice = parseFloat(item.price) || 0;

      if (item.qtyAndPrice && item.qtyAndPrice.length > 0) {
        const minQtyEntry = item.qtyAndPrice.reduce(
          (minEntry, currentEntry) => {
            return currentEntry.minQty < minEntry.minQty
              ? currentEntry
              : minEntry;
          },
          item.qtyAndPrice[0],
        );

        if (minQtyEntry) {
          const price = isB2C
            ? parseFloat(minQtyEntry.setB2cPrice)
            : parseFloat(minQtyEntry.setB2bPrice);
          return isNaN(price) ? basePrice : price;
        }
        return basePrice;
      }

      if (item.productVariant && item.productVariant.length > 0) {
        const sellingPrices = item.productVariant
          .map((variant) => {
            const variantPrice = parseFloat(variant.price) || 0;
            const discMode = isB2C
              ? (variant.b2cDiscountMode || "").toLowerCase()
              : (variant.b2bDiscountMode || "").toLowerCase();
            const discValue = isB2C
              ? parseFloat(variant.b2cDiscountValue) || 0
              : parseFloat(variant.b2bDiscountValue) || 0;

            let finalPrice = variantPrice;
            if (discMode === "percent") {
              finalPrice = variantPrice - (variantPrice * discValue) / 100;
            } else if (discMode === "amount") {
              finalPrice = variantPrice - discValue;
            }
            return Math.max(0, finalPrice);
          })
          .filter((p) => !isNaN(p) && p > 0);

        if (sellingPrices.length > 0) {
          return Math.min(...sellingPrices);
        }
        return basePrice;
      }

      const b2bMode = (item.b2bDiscountMode || "").toLowerCase();
      const b2cMode = (item.b2cDiscountMode || "").toLowerCase();

      let finalPrice = basePrice;
      if (isB2C) {
        if (b2cMode === "percent") {
          const disc = parseFloat(item.b2cDiscountValue) || 0;
          finalPrice = basePrice - (basePrice * disc) / 100;
        } else if (b2cMode === "amount") {
          const disc = parseFloat(item.b2cDiscountValue) || 0;
          finalPrice = basePrice - disc;
        }
      } else {
        if (b2bMode === "percent") {
          const disc = parseFloat(item.b2bDiscountValue) || 0;
          finalPrice = basePrice - (basePrice * disc) / 100;
        } else if (b2bMode === "amount") {
          const disc = parseFloat(item.b2bDiscountValue) || 0;
          finalPrice = basePrice - disc;
        }
      }

      return Math.max(0, finalPrice);
    };

  const toggleCategory = (id) => {
    setSelectedCategories((prev) => {
      const newSelected = prev.includes(id)
        ? prev.filter((c) => c !== id)
        : [...prev, id];
      if (newSelected.length > 0) {
        fetchBrandsByCategory(newSelected);
      } else {
        setFilteredBrand([]);
      }

      return newSelected;
    });
  };
  const toggleBrand = (id) => {
    setSelectedBrands((prev) =>
      prev.includes(id) ? prev.filter((b) => b !== id) : [...prev, id]
    );
  };
  const getProducts = async () => {
    setFetchLoading(true);

    const uniqueBrands = [...new Set(selectedBrands)];
    let url = `product/?productStatus=active&shopStatus=active`;

    if (categoryID) {
      url += `&flag=catProducts&bannerCatId=${categoryID}`;
      if (selectedCategories.length > 0) {
        url += `&categoryId=${selectedCategories.join(",")}`;
      }
    }
    if (uniqueBrands.length > 0) {
      url += `&brandId=${uniqueBrands.join(",")}`;
    }
    if (sortBy && sortBy !== "select") {
      url += `&type=${sortBy}`;
    }

    try {
      const response = await api.get(url);

      const products = (response.data.data || []).map((item) => {
        let matchedBrandId = null;
        const productName = item.name.toLowerCase();
        for (let brand of brandList) {
          if (productName.includes(brand.name.toLowerCase().split(" ")[0])) {
            matchedBrandId = brand.id;
            break;
          }
        }

        const productId = item.productId || item.id;
        const reviewsForThisProduct = allReviewData.filter(
          (r) => String(r.productId) === String(productId)
        );

        return {
          ...item,
          ratingAndReview: reviewsForThisProduct,
          productId: item.productId ?? item.id,
          categoryId: item.categoryId ?? item.category_id,
          shopId: item.shopId ?? item.shop_id,
          shopName: item.shopName ?? item.shop_name,
          deliveryCharge: item.deliveryCharge ?? item.delivery_charge,
          discountLabel: item.discountLabel ?? item.discount_label,
          discountMode: item.discountMode ?? item.discount_mode,
          discountValue: item.discountValue ?? item.discount_value,
          mainImage: item.mainImage ?? item.image ?? item.main_image,
          stockAvail: item.stockAvail ?? item.stock_avail,
          warrantyLabel: item.warrantyLabel ?? item.warranty_label,
          warrantyMode: item.warrantyMode ?? item.warranty_mode,
          warrantyPeriod: item.warrantyPeriod ?? item.warranty_period,
          brandId: matchedBrandId ?? item.brandId ?? item.brand_id,
        };
      });

      const uniqueProducts = [
        ...new Map(products.map((item) => [item.productId, item])).values(),
      ];
      setProductList(uniqueProducts);
      setFilteredList(uniqueProducts);
      if (uniqueProducts.length > 0) {
  const prices = uniqueProducts.map((p) =>
    getSellingPriceForFilter(p, customer),
  );        const min = Math.min(...prices);
        const max = Math.max(...prices);
        setPriceLimits({ min, max });
        setPriceRange([min, max]);
      }
    } catch (err) {
      setProductList([]);
      setFilteredList([]);
    } finally {
      setFetchLoading(false);
    }
  };
  const getCartData = () => {
    if (customer) {
      api
        .get("/cart/?customerId=" + customer.id, customerReqConfig())
        .then((response) => {
          if (response.status === 200) {
            setCartData(response.data.data);
          }
        })
        .catch((error) => {
          setCartData([]);
        })
        .finally();
    } else {
      setCartData([]);
    }
  };
  const [allReviewData, setAllReviewData] = useState([]);

  useEffect(() => {
    api
      .get("/rating_and_review/", customerReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setAllReviewData(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching reviews:", error);
      });
  }, []);


  const applyFilters = () => {
    const [min, max] = priceRange;

    const filtered = productList.filter((p) => {
      const sellingPrice = getSellingPriceForFilter(p, customer);
      const priceMatch = sellingPrice >= min && sellingPrice <= max;

      const avgRating = parseFloat(ratingAvg1(p.ratingAndReview)) || 0;
      let ratingMatch = true;

      if (selectedRating === 4) {
        ratingMatch = avgRating >= 4;
      } else if (selectedRating === 3) {
        ratingMatch = avgRating >= 3;
      } else if (selectedRating === "below3") {
        ratingMatch = avgRating < 3;
      }

      return priceMatch && ratingMatch;
    });

    setFilteredList(filtered);
  };
  const fetchBrandsByCategory = async (categoryIDs) => {
    if (!categoryIDs || categoryIDs.length === 0) {
      setFilteredBrand([]);
      return;
    }

    const idParam = Array.isArray(categoryIDs)
      ? categoryIDs.join(",")
      : categoryIDs;

    try {
      const response = await api.get(`/category/?flag=brandData&id=${idParam}`);

      const brands = response.data.data || [];
      setFilteredBrand(brands);
    } catch (error) {
      console.error("Failed to fetch brands:", error);
      setFilteredBrand([]);
    }
  };
  useEffect(() => {
    if (categoryID) {
      const id = parseInt(categoryID);
      setSelectedCategories([]);
      setSelectedBrands([]);
      fetchBrandsByCategory(id);
    } else {
      setSelectedCategories([]);
      setSelectedBrands([]);
      setFilteredBrand([]);
    }
  }, [categoryID]);
  useEffect(() => {
    getProducts();
  }, [selectedCategories, selectedBrands, sortBy]);
  useEffect(() => {
    applyFilters();
  }, [priceRange, selectedRating, productList]);

  useEffect(() => {
    if (allReviewData.length > 0) {
      getProducts();
    }
  }, [allReviewData]);
  return (
    <section className="shop py-80">
      <div className={`side-overlay ${active && "show"}`}></div>
      <div className="container container-lg">
        <div className="row">
          <div className="col-lg-3">
            <div className={`shop-sidebar ${active && "active"}`}>
              <button
                onClick={sidebarController}
                type="button"
                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
              >
                <i className="ph ph-x" />
              </button>
              <div className="shop-sidebar__box border border-gray-100 hover-border-main-600 transition-1 rounded-16 mb-32">
                <h6 className="text-xl ps-32 pe-32 pt-32 pb-3">
                  FILTERS
                </h6>
                <hr />

                <div className="d-flex justify-content-between ps-32 pe-32 pt-2 pb-2">
                  <h6 className="text-xl mt-1">
                    Category
                  </h6>
                  <div
                    className="text-danger text-md cursor-pointer d-inline-flex align-items-center gap-1 fw-bold"
                    onClick={() => {
                      setSelectedCategories([])
                      setSelectedBrands([])
                      setFilteredBrand([])
                    }
                    }
                  >
                    {/* <i className="fas fa-times"></i>  */}
                    Clear
                  </div>
                </div>
                <ul className="max-h-540 overflow-y-auto scroll-sm p-32">

                  {categoryList.map((item, index) => {
                    const textStyle =
                      item.id === categoryID
                        ? "text-main-600 hover-text-main-600 "
                        : "text-gray-900 hover-text-main-600";
                    return (
                      <li key={index} className="mb-24">
                        <label>
                          <input
                            type="checkbox"
                            checked={selectedCategories.includes(
                              Number(item.id)
                            )}
                            onChange={() => toggleCategory(Number(item.id))}
                            className={textStyle}
                          />{" "}
                          {item.name}
                        </label>
                      </li>
                    );
                  })}
                </ul>
                <hr />
                <div className="d-flex justify-content-between ps-32 pe-32 pt-2 pb-2">
                  <h6 className="text-xl mt-1">
                    Price
                  </h6>
                  <div
                    className="text-danger text-md cursor-pointer d-inline-flex align-items-center gap-1 fw-bold"
                    onClick={() => {
                      setPriceRange([priceLimits.min, priceLimits.max]);
                      setFilteredList(productList);
                    }}
                  >
                    {/* <i className="fas fa-times"></i>  */}
                    Clear
                  </div>
                </div>
                <div className="custom--range p-32">
                  <ReactSlider
                    className="horizontal-slider z-1"
                    thumbClassName="example-thumb"
                    trackClassName="example-track"
                    value={priceRange}
                    onChange={(value) => setPriceRange(value)}
                    ariaLabel={["Lower thumb", "Upper thumb"]}
                    // renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                    renderThumb={(props, state) => (
                      <div {...props} className="example-thumb">
                        ₹{state.valueNow}
                      </div>
                    )}
                    pearling
                    minDistance={10}
                    min={priceLimits.min}
                    max={priceLimits.max}
                  />
                  <br />
                  <br />
                </div>
                <hr />
                <div className="d-flex justify-content-between ps-32 pe-32 pt-2 pb-2">
                  <h6 className="text-xl mt-1">
                    Brand
                  </h6>
                  <div
                    className="text-danger text-md cursor-pointer d-inline-flex align-items-center gap-1 fw-bold"
                    onClick={() => setSelectedBrands([])}

                  >
                    {/* <i className="fas fa-times"></i>  */}
                    Clear
                  </div>
                </div>
                <ul className="max-h-540 overflow-y-auto scroll-sm p-32">
                  {filteredBrands.map((item, index) => {
                    const textStyle =
                      item.id === categoryID
                        ? "text-main-600 hover-text-main-600 "
                        : "text-gray-900 hover-text-main-600";
                    return (
                      <li key={index} className="mb-24">
                        <label>
                          <input
                            type="checkbox"
                            checked={selectedBrands.includes(item.id)}
                            onChange={() => toggleBrand(item.id)}
                            className={textStyle}
                          />{" "}
                          {item.name}
                        </label>
                      </li>
                    );
                  })}
                </ul>
                <hr />
                <div className="d-flex justify-content-between ps-32 pe-32 pt-2 pb-2">
                  <h6 className="text-xl mt-1">
                    Ratings
                  </h6>
                  <div
                    className="text-danger text-md cursor-pointer d-inline-flex align-items-center gap-1 fw-bold"
                    onClick={() => setSelectedRating(null)}
                  >
                    {/* <i className="fas fa-times"></i>  */}
                    Clear
                  </div>
                </div>
                <ul className="max-h-540 overflow-y-auto scroll-sm p-32">
                  <li className="mb-24">
                    <label>
                      <input
                        type="checkbox"
                        checked={selectedRating === 4}
                        onChange={() => setSelectedRating(selectedRating === 4 ? null : 4)}
                      />{" "}
                      4 ★ & Above
                    </label>
                  </li>
                  <li className="mb-24">
                    <label>
                      <input
                        type="checkbox"
                        checked={selectedRating === 3}
                        onChange={() => setSelectedRating(selectedRating === 3 ? null : 3)}
                      />{" "}
                      3 ★ & Above
                    </label>
                  </li>
                  <li className="mb-24">
                    <label>
                      <input
                        type="checkbox"
                        checked={selectedRating === "below3"}
                        onChange={() =>
                          setSelectedRating(selectedRating === "below3" ? null : "below3")
                        }
                      />{" "}
                      Below 3 ★
                    </label>
                  </li>
                </ul>


                <hr />
                <div className="d-flex justify-content-between ps-32 pe-32 pt-2 pb-2">
                  <h6 className="text-xl mt-1">
                    Grade
                  </h6>
                  <div
                    className="text-danger text-md cursor-pointer d-inline-flex align-items-center gap-1 fw-bold"
                  >
                    {/* <i className="fas fa-times"></i>  */}
                    Clear
                  </div>
                </div>
                <ul className="max-h-540 overflow-y-auto scroll-sm p-32">

                  <li className="mb-24">
                    <label>
                      <input
                        type="checkbox"
                      />{" "}
                      OPC 33,43 & 53
                    </label>
                  </li>
                  <li className="mb-24">
                    <label>
                      <input
                        type="checkbox"
                      />{" "}
                      PPC 33,43 & 53
                    </label>
                  </li>
                </ul>
                <hr />
                <div className="d-flex justify-content-between ps-32 pe-32 pt-2 pb-2">
                  <h6 className="text-xl mt-1">
                    IS Certification
                  </h6>
                  <div
                    className="text-danger text-md cursor-pointer d-inline-flex align-items-center gap-1 fw-bold"
                  >
                    {/* <i className="fas fa-times"></i>  */}
                    Clear
                  </div>
                </div>
                <ul className="max-h-540 overflow-y-auto scroll-sm p-32">

                  <li className="mb-24">
                    <label>
                      <input
                        type="checkbox"
                      />{" "}
                      IS 1269
                    </label>
                  </li>
                  <li className="mb-24">
                    <label>
                      <input
                        type="checkbox"
                      />{" "}
                      IS 1489
                    </label>
                  </li>
                </ul>
                <div className="d-flex justify-content-between ps-32 pe-32 pt-2 pb-2">
                  <div>
                  </div>
                  <button
                    className=" btn btn-outline-main d-flex align-items-center justify-content-right mb-32"
                    onClick={() => {
                      setSelectedCategories([]);
                      setSelectedBrands([]);
                      setPriceRange([priceLimits.min, priceLimits.max]);
                      setSelectedRating(null);
                      // setSelectedGrades([]);        
                      // setSelectedISCerts([]);       
                      setFilteredList(productList);
                    }}
                  >
                    Reset
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div className="col-lg-9">
            <div className="flex-between gap-16 flex-wrap mb-40 ">
              <span className="text-gray-900">
                Showing {filteredList.length} products
              </span>
              <div className="position-relative flex-align gap-16 flex-wrap">
                <div className="list-grid-btns flex-align gap-16">
                  <button
                    onClick={() => setGrid(true)}
                    type="button"
                    className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${grid === true && "border-main-600 text-white bg-main-600"
                      }`}
                  >
                    <i className="ph-bold ph-list-dashes" />
                  </button>
                  <button
                    onClick={() => setGrid(false)}
                    type="button"
                    className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${grid === false && "border-main-600 text-white bg-main-600"
                      }`}
                  >
                    <i className="ph ph-squares-four" />
                  </button>
                </div>
                <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                  <label
                    htmlFor="sorting"
                    className="text-inherit flex-shrink-0"
                  >
                    Sort by:{" "}
                  </label>
                  <select
                    className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                    id="sorting"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="popular">Popular</option>
                    <option value="latest">Latest</option>
                    <option value="trending">Trending</option>
                    {/* <option value={1}>Matches</option> */}
                  </select>
                </div>
                <button
                  onClick={sidebarController}
                  type="button"
                  className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                >
                  <i className="ph-bold ph-funnel" />
                </button>
              </div>
            </div>
                     <div className={`list-grid-wrapper ${grid && "list-view"}`}>
              {filteredList?.map((item, index) => {
                // Render different component based on view mode
                return grid ? (
                  <CatProductListStyle
                    product={item}
                    key={index}
                    fetchcart={getCartData}
                    fetchCartCount={fetchCartCount}
                    cartData={cartData}
                    setCartData={setCartData}
                  />
                ) : (
                  <CatProductGridStyle
                    product={item}
                    key={index}
                    fetchcart={getCartData}
                    fetchCartCount={fetchCartCount}
                    cartData={cartData}
                    setCartData={setCartData}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default BannersCategoryProductList;


